import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationCheckService } from './authentication-check.service';

@Injectable({
    providedIn: 'root'
})
export class OnboardguardService implements CanActivate {
    constructor(private authService: AuthenticationCheckService, private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Example: Check if the user is authenticated before allowing access to the route
        if (!this.authService.isAuthenticated()) {
            return true;  // Allow the route to be activated (route is protected)
        } else {
            // Redirect to the login page or another page if the user is authenticated
            this.router.navigate(['/signin']);  // Change '/login' to the appropriate route
            return false;  // Block the route activation
        }
    }
}
